import React from "react";
import style from "./OptionList.module.scss";
import InfoIcon from "../../../static/images/info.svg";
import Tooltip from "../Tooltip/tooltip";

const defaultGetKey = (o) => o.option;
const defaultGetLabel = (o) => o.option;
const defaultGetDescription = (o) => o.description;
const defaultGetApiValue = (o) => (o.value !== undefined && o.value !== null && o.value !== "" ? o.value : o.option);

const OptionList = ({
  name,
  value,
  onChange,
  options = [],
  disabled = false,
  getOptionKey = defaultGetKey,
  getOptionLabel = defaultGetLabel,
  getOptionDescription = defaultGetDescription,
  getOptionApiValue = defaultGetApiValue,
}) => {
  return (
    <div className={style.option_list} role="radiogroup" aria-label={name}>
      {options.map((option) => {
        const key = getOptionKey(option);
        const label = getOptionLabel(option);
        const description = getOptionDescription(option);
        const apiValue = getOptionApiValue(option);
        const hasDesc = description && description !== "-" && description !== "None";
        const isSelected = value === key;

        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={isSelected}
            disabled={disabled}
            className={`${style.option_row} ${isSelected ? style.option_row_selected : ""}`}
            onClick={() => onChange(name, key, apiValue)}
          >
            <span className={style.option_text}>
              {hasDesc && (
                <Tooltip placement="right" width="400px" content={description}>
                  <img src={InfoIcon} alt="" className={style.chip_icon} />
                </Tooltip>
              )}
              <span className={style.option_label}>{label}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default OptionList;
